import {Mapper} from '../../../../../core/abstracts/mapper.abstract';
import {VehicleReleaseModalResult} from '../model/vehicle-release-modal-result.model';
import {VehicleReleaseRequest} from '../model/vehicle-release.request';
import {Injectable} from '@angular/core';
import {DateTime} from 'luxon';

@Injectable({providedIn: 'root'})
export class VehicleReleaseRequestMapper extends Mapper<VehicleReleaseModalResult, VehicleReleaseRequest> {
  override map(source: VehicleReleaseModalResult): VehicleReleaseRequest {
    return new VehicleReleaseRequest(
      this.resolveFromDateTime(source.vehicleReleaseDate),
      source.vehicleReleasePerson);
  }

  private resolveFromDateTime(dateTime: DateTime): string {
    return dateTime.toISO({includeOffset: false}) as string;
  }
}
